export interface TeamMember {
  name: string;
  initials: string;
  title: string;
  practiceAreas: string[];
  education?: string[];
  barAdmission?: string;
  bio: string;
  featured: boolean;
}

export const teamMembers: TeamMember[] = [
  {
    name: 'Charlotte M. Janssen',
    initials: 'CJ',
    title: 'Owner & Founder',
    practiceAreas: [
      'Mergers & Acquisitions',
      'Corporate/Commercial',
      'Real Estate',
      'International Business',
      'Immigration',
      'Banking & Finance',
      'Securities',
      'Elder Law',
      'Wills, Estates & Trusts',
    ],
    education: [
      'University of Toronto, J.D. (1986)',
      'Carleton University, M.A. (Economics)',
      'University of Manitoba, B.A. Honours (1982)',
    ],
    barAdmission: '1988, Law Society of Upper Canada (Ontario)',
    bio: 'Charlotte has been practicing law in private practice for almost 30 years. Currently the owner and manager of Janssen Law Professional Corporation, she advises business owners of Canadian and international businesses. Consistent with in-house counsel, she provides a vast array of legal advice in the areas of Corporate, Commercial, Finance, Immigration, Real Estate, and Wills, Estates, and Trusts to high net worth clients. Prior to establishing her own firm in 1996, she worked with Baker & McKenzie in Toronto (Canada), S\u00e3o Paulo (Brazil), and London (UK) and as a partner of the firm Baker & Janssen. She also serves as a director of numerous private companies and community organizations.',
    featured: true,
  },
  {
    name: 'Janith',
    initials: 'J',
    title: 'Lawyer',
    practiceAreas: ['Real Estate'],
    bio: 'Janith brings focused expertise in real estate law, assisting clients with residential and commercial property transactions, title searches, mortgage documentation, and land transfer matters across Ontario.',
    featured: false,
  },
  {
    name: 'Linh',
    initials: 'L',
    title: 'Lawyer',
    practiceAreas: ['Commercial Law', 'Immigration', 'Real Estate'],
    bio: 'Linh provides comprehensive legal counsel across commercial transactions, immigration matters, and real estate. With expertise spanning multiple practice areas, Linh delivers versatile and practical legal solutions for clients with diverse legal needs.',
    featured: false,
  },
  {
    name: 'Vitor',
    initials: 'V',
    title: 'Immigration Specialist',
    practiceAreas: [],
    bio: 'Vitor provides essential support across all practice areas, ensuring efficient case management, document preparation, and client communication throughout the legal process.',
    featured: false,
  },
];
